import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./CustomDateRangeMobile.scss";

import { DateRange } from "react-date-range";
import format from "date-fns/format";
import endOfDay from "date-fns/endOfDay";
import {
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Portal,
  Box,
} from "@chakra-ui/react";

interface CustomDateRangeProps {
  range: any[];
  onChange: (item: any) => void;
}

export default function CustomDateRangeMobile({
  range,
  onChange,
}: CustomDateRangeProps): JSX.Element {
  const handleDateChange = (item: any) => {
    const newStartDate = item.selection.startDate;
    let newEndDate = item.selection.endDate;

    // If the same date is selected for both start and end, set the endDate to the end of the day
    if (newStartDate.toDateString() === newEndDate.toDateString()) {
      newEndDate = endOfDay(newEndDate);
    }

    onChange({
      selection: {
        startDate: newStartDate,
        endDate: newEndDate,
        key: "selection",
      },
    });
  };

  return (
    <Popover placement="auto">
      <>
        <PopoverTrigger>
          <Input
            name="datePicker"
            value={`${format(range[0].startDate, "MM/dd/yyyy")} to ${format(
              range[0].endDate,
              "MM/dd/yyyy"
            )}`}
            w={{ base: "100%", lg: "18rem" }}
            textAlign="center"
            bg="#f8f9fa"
            borderColor="teal.500" // Optional: Match border color with the desktop version
          />
        </PopoverTrigger>
        <PopoverContent>
          <Box>

            <PopoverBody >
              <DateRange
                onChange={handleDateChange}
                editableDateInputs={true}
                moveRangeOnFirstSelection={false}
                ranges={range}
                months={1}
                direction="horizontal"
                className="calendarElementMobile"
                rangeColors={["#38B2AC"]}
                showDateDisplay={false}
              />
            </PopoverBody>
          </Box>
        </PopoverContent>
      </>
    </Popover>
  );
}
